export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST"
export const FORGOT_PASSWORD_END_PROCESS = "FORGOT_PASSWORD_END_PROCESS"
